import { json, type LoaderFunctionArgs } from '@remix-run/node';
import type { ShouldRevalidateFunction } from '@remix-run/react';
import { getConversationFilters } from '~/modules/chat/api/get-conversation-filters.server';
import { CREATE_CONVERSATION_MESSAGE_API } from './remix-api.chat.create-conversation-message';
import { MARK_CONVERSATION_READ_API } from './remix-api.chat.mark-conversation-read';
import { MARK_CONVERSATION_UNREAD_API } from './remix-api.chat.mark-conversation-unread';
import { UPDATE_CONVERSATION_THUMBNAIL_API } from './remix-api.chat.update-thumbnail';
import { MUTE_CONVERSATION_API } from './remix-api.chat.mute';
import { REACT_MESSAGE_API } from './remix-api.chat.react-message';
import { DELETE_MESSAGE_API } from './remix-api.chat.delete-message';
import { UPDATE_CONVERSATION_SETTINGS_API } from './remix-api.chat.update-settings';

export const CONVERSATION_FILTERS_API_ROUTE =
    '/remix-api/chat/conversation-filters';

/**
 * API endpoint to get conversation filters for the current user.
 * Use with the `useConversationFilters` hook.
 * @see {@link packages/web/app/modules/chat/hooks/use-conversation-filters.ts}
 */
export const loader = async ({ context }: LoaderFunctionArgs) => {
    const { logger } = context;

    try {
        const conversationFilters = await getConversationFilters({ context });

        if (!conversationFilters) {
            return json(null, { status: 500 });
        }

        return json({ projects: conversationFilters.Projects });
    } catch (error) {
        logger.error(`Error in ${CONVERSATION_FILTERS_API_ROUTE}`, { error });
        return json(null, { status: 500 });
    }
};

export const shouldRevalidate: ShouldRevalidateFunction = ({
    defaultShouldRevalidate,
    formAction,
}) => {
    if (
        formAction === CREATE_CONVERSATION_MESSAGE_API ||
        formAction === MARK_CONVERSATION_READ_API ||
        formAction === MARK_CONVERSATION_UNREAD_API ||
        formAction === UPDATE_CONVERSATION_THUMBNAIL_API ||
        formAction === MUTE_CONVERSATION_API ||
        formAction === REACT_MESSAGE_API ||
        formAction === DELETE_MESSAGE_API ||
        formAction === UPDATE_CONVERSATION_SETTINGS_API
    ) {
        return false;
    }
    // Should be revalidated when chat project settings are updated.
    return defaultShouldRevalidate;
};
